import styled from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: ${tokens.zIndex.modal};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const Dialog = styled.div`
  background: ${tokens.color.cardCharcoal};
  border-radius: ${tokens.radius.md};
  border: 1px solid ${tokens.color.railGraphite};
  padding: 24px;
  width: 100%;
  max-width: 440px;
  color: ${tokens.color.textWhite};
`;

export const Title = styled.h2`
  color: ${tokens.color.textWhite};
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 8px 0;
`;

export const Description = styled.p`
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.body.size};
  margin: 0 0 20px 0;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const CancelButton = styled.button`
  background: transparent;
  border: 1px solid ${tokens.color.railGraphite};
  color: ${tokens.color.textWhite};
  border-radius: 8px;
  height: 44px;
  padding: 0 20px;
  margin-top: ${tokens.space.lg};
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: ${tokens.color.railGraphite};
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }
`;
